import { defineMessages } from 'react-intl';

/**
 * Link messages for error pages.
 * These contain the URLs that are used in the helpful links section.
 * The defaultMessage values are the English URLs (fallback).
 * Translations for DE/FR are defined in the locale .po files.
 */
export const linkMessages = defineMessages({
  degreeProgrammesSearchLink: {
    id: 'error.degreeprogrammes.link',
    defaultMessage: '/en/degree-programmes/offerings/programmes',
  },
  continuingEducationSearchLink: {
    id: 'error.continuing.link',
    defaultMessage: '/en/continuing-education/offerings/programmes',
  },
  phContinuingEducationSearchLink: {
    id: 'error.continuing.ph.link',
    defaultMessage:
      'https://www.fhnw.ch/de/ph/weiterbildung/angebot/weiterbildungen',
  },
  infoEventsDegreeLink: {
    id: 'error.infoevents.degree',
    defaultMessage: '/en/degree-programmes/offerings/info-events',
  },
  infoEventsContinuingLink: {
    id: 'error.infoevents.cont',
    defaultMessage: '/en/continuing-education/offerings/info-events',
  },
  eventsSearchLink: {
    id: 'error.events.link',
    defaultMessage: '/en/news-events/events/all',
  },
  newsRoomLink: {
    id: 'error.news.link',
    defaultMessage: '/en/news-events/news-stories/all',
  },
  personsSearchLink: {
    id: 'error.persons.link',
    defaultMessage: '/en/about-fhnw/profile-organisation/people',
  },
  siteAdminLink: {
    id: 'error.help.link',
    defaultMessage: '/en/imprint',
  },
});

/**
 * Content messages for error pages.
 * These contain the titles, descriptions and link texts.
 */
export const contentMessages = defineMessages({
  // Degree programmes section
  degreeProgrammesTitle: {
    id: 'error.404.degreeprogrammes',
    defaultMessage: 'Degree programmes',
  },
  degreeProgrammesDesc: {
    id: 'error.404.degreeprogrammes.desc',
    defaultMessage:
      'If you are looking for a degree programme, use our {link}.',
  },
  degreeProgrammesLinkText: {
    id: 'error.404.degreeprogrammes.link',
    defaultMessage: 'degree programme search',
  },

  // Continuing education section
  continuingTitle: {
    id: 'error.404.continuing',
    defaultMessage: 'Continuing educations',
  },
  continuingDesc: {
    id: 'error.404.continuing.desc',
    defaultMessage:
      'If you are looking for a continuing education programme, use our {link}.',
  },
  continuingLinkText: {
    id: 'error.404.continuing.link',
    defaultMessage: 'continuing education search',
  },

  // PH continuing education section (DE only)
  phContinuingTitle: {
    id: 'error.404.continuing.ph',
    defaultMessage: 'Continuing educations at PH FHNW',
  },
  phContinuingDesc: {
    id: 'error.404.continuing.ph.desc',
    defaultMessage:
      'If you are looking for a continuing education programme at PH FHNW, use the {link}.',
  },
  phContinuingLinkText: {
    id: 'error.404.continuing.ph.link',
    defaultMessage: 'continuing education search of PH FHNW',
  },

  // Information events section
  infoEventsTitle: {
    id: 'error.404.infoevents',
    defaultMessage: 'Information events',
  },
  infoEventsDesc: {
    id: 'error.404.infoevents.desc',
    defaultMessage:
      'If you are looking for an information event, use our information event search for {degree} or {cont}.',
  },
  infoEventsDegreeLinkText: {
    id: 'error.404.infoevents.degree',
    defaultMessage: 'degree programmes',
  },
  infoEventsContLinkText: {
    id: 'error.404.infoevents.cont',
    defaultMessage: 'continuing education',
  },

  // Events section
  eventsTitle: {
    id: 'error.404.events',
    defaultMessage: 'Events',
  },
  eventsDesc: {
    id: 'error.404.events.desc',
    defaultMessage: 'If you are looking for another event, use our {link}.',
  },
  eventsLinkText: {
    id: 'error.404.events.link',
    defaultMessage: 'event search',
  },

  // News section
  newsTitle: {
    id: 'error.404.news',
    defaultMessage: 'News',
  },
  newsDesc: {
    id: 'error.404.news.desc',
    defaultMessage: 'If you are looking for a news article, use our {link}.',
  },
  newsLinkText: {
    id: 'error.404.news.link',
    defaultMessage: 'newsroom',
  },

  // Persons section
  personsTitle: {
    id: 'error.404.persons',
    defaultMessage: 'Persons',
  },
  personsDesc: {
    id: 'error.404.persons.desc',
    defaultMessage:
      'If you are looking for a person at the FHNW, use our {link}.',
  },
  personsLinkText: {
    id: 'error.404.persons.link',
    defaultMessage: 'search for persons',
  },

  // Other section
  otherTitle: {
    id: 'error.404.other',
    defaultMessage: 'Other',
  },
  otherDesc: {
    id: 'error.404.other.desc',
    defaultMessage:
      'If you are looking for something else, use our search function with the magnifying glass at the top right of the website.',
  },

  // Help section
  helpDesc: {
    id: 'error.404.help',
    defaultMessage:
      'If you are certain you have the correct web address but are encountering an error, please contact the {siteAdmin}.',
  },
  helpLinkText: {
    id: 'error.404.help.link',
    defaultMessage: 'site administration',
  },

  // Thank you
  thanks: {
    id: 'error.404.thanks',
    defaultMessage: 'Thank you.',
  },
});
